import React from 'react'
import { Text } from '@react-pdf/renderer'

import styles from './styles'
import { TColumn } from './Table'
import { toStyleArray } from './utils'
import { useTranslation } from 'react-i18next'

import {
  commonStyles,
  createDirectionalStyles,
} from 'src/parser/shared/PDF/Title/CommonUtils'

const TableCell = <Cols extends string, Row extends Record<Cols, unknown>>({
  column,
  columnKey,
  row,
}: {
  column: TColumn<Cols, Row[Cols]>
  columnKey: Cols
  row: Row
}): JSX.Element => {
  const { i18n } = useTranslation()
  const directionalStyles = createDirectionalStyles(commonStyles, i18n.language)

  return (
    <Text
      style={[
        styles.cell,
        styles.contentCell,
        ...toStyleArray(column.style),
        directionalStyles.textAlign,
      ]}
    >
      {column.render(row[columnKey], columnKey)}
    </Text>
  )
}

export default TableCell
